import React from 'react';

// Component
import GameArea from '../GameArea/GameArea';
import FuncArea from '../FuncArea/FuncArea';

// CSS
import '../../css/Home.css';
import '../../css/FuncArea.css';

function Home() {
    const cardArray = [['♣ 7', '♥ 3', '♠ J', '♣ 10', '♦ A', '♠ A', '♦ 5'], ['♥ J', '♠ 5', '♠ 3', '♣ 5', '♥ 5', '♠ 2', '♥ A'],
        ['♦ 7', '♣ 8', '♣ 9', '♦ 8', '♥ Q', '♦ Q', '♠ 6'], ['♣ 2', '♣ 3', '♦ 6', '♠ 9', '♠ 8', '♠ Q', '♥ 6'],
        ['♦ 4', '♥ 9', '♣ Q', '♠ K', '♥ 10', '♦ 9'], ['♣ 6', '♣ A', '♥ 7', '♦ 3', '♥ 2', '♠ 10'],
        ['♥ 8', '♠ 7', '♥ K', '♦ 2', '♦ K', '♣ J'], ['♣ K', '♥ 4', '♦ 10', '♦ J', '♣ 4', '♠ 4']];
    return (
        <div className="Home">
            <GameArea cardArray={cardArray} />
            <FuncArea />
        </div>
    );
}

export default Home;
